// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_uq-8";
export var editMode = "_uq-3";
export var headerRow = "_uq-a";
export var headerTitle = "_uq-b";
export var product = "_uq-1";
export var productDetails = "_uq-5";
export var productDivider = "_uq-7";
export var productImage = "_uq-2";
export var productInfo = "_uq-4";
export var productTitle = "_uq-6";
export var strikethrough = "_uq-9";
export var upsellProductsCard = "_uq-0";